export default __webpack_public_path__ + "static/media/clarity_contract-line.6cfe4aa4.svg";